!function (e, r) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = r(require("react"));else if ("function" === typeof define && define.amd) define(["react"], r);else {
    var t = "object" === typeof exports ? r(require("react")) : r(e.react);

    for (var n in t) {
      ("object" === typeof exports ? exports : e)[n] = t[n];
    }
  }
}(window, function (e) {
  return function (e) {
    var r = {};

    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, r) {
      if (1 & r && (e = t(e)), 8 & r) return e;
      if (4 & r && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var o in e) {
        t.d(n, o, function (r) {
          return e[r];
        }.bind(null, o));
      }
      return n;
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.p = "/jyash97/marketplace-footer/", t(t.s = 1);
  }([function (r, t) {
    r.exports = e;
  }, function (e, r, t) {
    e.exports = t(3);
  }, function (e, r, t) {}, function (e, r, t) {
    "use strict";

    function n(e, r) {
      if (null == e) return {};

      var t,
          n,
          o = function (e, r) {
        if (null == e) return {};
        var t,
            n,
            o = {},
            a = Object.keys(e);

        for (n = 0; n < a.length; n++) {
          t = a[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
        }

        return o;
      }(e, r);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (n = 0; n < a.length; n++) {
          t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
        }
      }

      return o;
    }

    t.r(r);
    var o = t(0),
        a = t.n(o),
        u = (t(2), function (e) {
      var r = e.url,
          t = e.price,
          o = n(e, ["url", "price"]);
      return a.a.createElement(a.a.Fragment, null, a.a.createElement("div", Object.assign({
        className: "footer"
      }, o), a.a.createElement("p", null, "This app is part of the ReactiveSearch Marketplace. You can check more apps ", a.a.createElement("a", {
        rel: "noopener noreferrer",
        target: "_blank",
        href: "https://reactiveapps.io"
      }, "here"), "."), a.a.createElement("a", {
        className: "button",
        rel: "noopener noreferrer",
        target: "_blank",
        href: r
      }, "Buy Now ", t ? a.a.createElement("span", null, "for ", t) : "")));
    });
    r.default = u;
  }]);
});